import { Grid } from "@mui/material";
import React from "react";
import moment from "moment";

import lateIcon from "../../../../styles/svg/warning-icon.svg";
import CustomizedProgressBars from "../../../board/components/progressBar/ProgressBar";
import { fixedDigitsAfterDecimal, SanitizedHtml } from "../../../../utils";
import { useResponsive } from "../../../../hooks/useResponsive";

export const ByBoardAndUserProgressBar = ({ sameDay, worklog }) => {
  const isMobile = useResponsive("down", "md");
  return isMobile ? (
    <Grid
      item
      xs={12}
      md={3}
      sx={{
        paddingLeft: "4px !important",
        paddingRight: "4px !important",
      }}>
      {/* <p className="worklog-title mr-2 ml-2">{worklog?.cardlog?.card?.title}</p> */}
      <SanitizedHtml
        as="div"
        className="worklog-worklog-mobile"
        html={worklog?.cardlog?.work_performed}
      />
      <div className="mt-2">
        <p className="worklog-date-time">
          {!sameDay && <img src={lateIcon} className="late-icon" />}
          {moment
            .utc(worklog?.cardlog?.date_time)
            .local()
            .format("MMMM D, YYYY [at] h:mm A")}
        </p>
        <CustomizedProgressBars
          allocatedHours={worklog?.cardlog?.card?.allocated_hours}
          hoursSpent={fixedDigitsAfterDecimal(worklog?.cardlog?.hours_spent)}
        />
        <p className="created-date-worklog">
          {`Created at ${moment
            .utc(worklog?.cardlog?.modified_at)
            .local()
            .format("MMMM D, YYYY [at] h:mm A")}`}
        </p>
      </div>
    </Grid>
  ) : (
    <Grid item xs={12} md={3}>
      <div className="right-details">
        <div className="d-flex justify-content-end">
          <p className="worklog-status">{worklog?.workflow_step_name}</p>
        </div>
        <p className="worklog-date-time">
          {!sameDay && (
            <img src={lateIcon} className="late-icon" alt="not found" />
          )}
          {moment
            .utc(worklog?.cardlog?.date_time)
            ?.local()
            ?.format("MMMM D, YYYY [at] h:mm A")}
        </p>
        <CustomizedProgressBars
          allocatedHours={worklog?.cardlog?.card?.allocated_hours}
          hoursSpent={fixedDigitsAfterDecimal(worklog?.total_hour_spent)}
        />
        <p className="created-date-worklog">
          {`Created at ${moment
            .utc(worklog?.cardlog?.modified_at)
            ?.local()
            ?.format("MMMM D, YYYY [at] h:mm A")}`}
        </p>
      </div>
    </Grid>
  );
};
